import { c as _c } from "react/compiler-runtime";
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
const variants = cva('gap-0.5 rounded-md px-1 py-0.5 text-sm font-medium flex w-fit items-center select-none', {
  variants: {
    variant: {
      primary: 'text-text-hover',
      secondary: 'text-text-brand-secondary',
      tertiary: 'text-text-brand-tertiary',
      warning: 'text-text-error',
      custom: 'text-text-secondary'
    },
    style: {
      outline: 'border',
      solid: ''
    },
    disabled: {
      true: 'text-text-disabled pointer-events-none',
      false: ''
    }
  },
  compoundVariants: [{
    variant: 'primary',
    style: 'outline',
    disabled: false,
    className: 'border-text-brand-primary bg-white'
  }, {
    variant: 'primary',
    style: 'solid',
    disabled: false,
    className: 'bg-surface-brand-primary-light'
  }, {
    variant: 'secondary',
    style: 'outline',
    disabled: false,
    className: 'border-border-brand-secondary bg-white'
  }, {
    variant: 'secondary',
    style: 'solid',
    disabled: false,
    className: 'bg-surface-brand-secondary-subtle'
  }, {
    variant: 'tertiary',
    style: 'outline',
    disabled: false,
    className: 'border-border-brand-tertiary bg-white'
  }, {
    variant: 'tertiary',
    style: 'solid',
    disabled: false,
    className: 'bg-surface-brand-tertiary-subtle'
  }, {
    variant: 'warning',
    style: 'outline',
    disabled: false,
    className: 'border-text-error bg-white'
  }, {
    variant: 'warning',
    style: 'solid',
    disabled: false,
    className: 'bg-surface-error-disabled'
  }, {
    variant: 'custom',
    style: 'outline',
    disabled: false,
    className: 'border-border-enabled bg-white'
  }, {
    variant: 'custom',
    style: 'solid',
    disabled: false,
    className: 'bg-surface-neutral'
  }, {
    style: 'outline',
    disabled: true,
    className: 'border-border-disabled'
  }, {
    style: 'solid',
    disabled: true,
    className: 'bg-surface-disabled'
  }],
  defaultVariants: {
    variant: 'primary',
    style: 'outline',
    disabled: false
  }
});
interface Props extends VariantProps<typeof variants> {
  text: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
}
export function Tag(t0) {
  const $ = _c(16);
  const {
    variant,
    style,
    text,
    disabled,
    icon,
    iconPosition
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== style || $[2] !== variant) {
    t1 = cn(variants({
      variant,
      style,
      disabled
    }));
    $[0] = disabled;
    $[1] = style;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = disabled ? "true" : undefined;
  let t3;
  if ($[4] !== icon || $[5] !== iconPosition) {
    t3 = icon && iconPosition === "left" && <span className="size-1.5">{icon}</span>;
    $[4] = icon;
    $[5] = iconPosition;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== icon || $[8] !== iconPosition) {
    t4 = icon && iconPosition === "right" && <span className="size-1.5">{icon}</span>;
    $[7] = icon;
    $[8] = iconPosition;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== text) {
    t5 = <div className={t1} aria-disabled={t2}>{t3}{text}{t4}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = text;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}